<template>
  <div class="product-detail">
    <Nav :isColor="isPC" class="bg-nav" />
    <div class="product-card">
      <div class="description"><span>商品简介</span></div>
      <div class="product-box">
        <img :src="product.coverUrl" class="product-cover" />
        <!-- 模态框 -->
        <div id="imageModal" class="modal">
          <span class="close" id="closeBtn">&times;</span>
          <img id="modalImage" class="modal-content" alt="Enlarged Product Image" />
        </div>
        <div class="main">
          <p class="name">{{ product.goodsName }}</p>
          <ul id="ul" class="content-box">
            <li>
              价格：
              <span class="content">¥{{ product.goodsPrice }}</span>
            </li>
            <li>
              规格：
              <span class="content">{{ product.goodsSpec }}</span>
            </li>
            <li>
              详情介绍：
              <span class="content">{{ product.goodsDetails }}</span>
            </li>
            <li>
              产品功效：
              <span class="content">{{ product.goodsEfficacy }}</span>
            </li>
            <li>
              肌肤类型：
              <span class="content">{{ product.skinType }}</span>
            </li>
            <li>
              适用人群：
              <span class="content">{{ product.applicablePeople }}</span>
            </li>
            <li>
              主要成分：
              <span class="content">{{ product.mainComponent }}</span>
            </li>
            <li>
              针对：
              <span class="content">{{ product.aim }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="product-info">
      <div v-for="(image, index) in product.imageList" :key="index">
        <img :src="image" alt="商品图片" class="product-image" />
      </div>
    </div>

    <Footer class="top" v-if="isPC" />
    <PhFooter v-else></PhFooter>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
import { getProductById } from '@/api/index' // 假设你有一个API文件来处理请求

export default {
  name: 'ProductDetail',
  comments: { Nav, Footer },
  data() {
    return {
      product: {},
      outerWidth: window.innerWidth, // 屏幕宽度
      error: null
    }
  },
  components: {
    Nav,
    Footer
  },
  async created() {
    try {
      const productId = this.$route.params.id
      // console.log('Fetching product with ID:', productId)
      const response = await getProductById(productId)
      // console.log('Product data received:', response)
      if (response.code === 200) {
        this.product = response.data
      } else {
        throw new Error(response.msg || '获取产品详情失败')
      }
    } catch (error) {
      console.error('获取产品详情失败:', error)
      this.error = '获取产品详情失败，请稍后再试'
      // 可以添加更多的错误处理逻辑，比如显示一个错误提示
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.updatePosterImage)
    // 初始化封面图
    this.updatePosterImage()

    // 获取图片和模态框元素
    const productImages = document.querySelectorAll('.product-cover')
    const imageModal = document.getElementById('imageModal')
    const modalImage = document.getElementById('modalImage')
    const closeBtn = document.getElementById('closeBtn')

    // 为所有的产品图片添加点击事件
    productImages.forEach((image) => {
      image.onclick = function () {
        // 点击缩略图时显示模态框
        imageModal.style.display = 'flex'
        modalImage.src = image.src // 设置模态框中显示的图片为点击的图片
      }
    })

    // 点击关闭按钮时关闭模态框
    closeBtn.onclick = function () {
      imageModal.style.display = 'none'
    }

    // 点击模态框外部区域时也关闭模态框
    imageModal.onclick = function (event) {
      if (event.target === imageModal) {
        imageModal.style.display = 'none'
      }
    }
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePosterImage)
  },
  methods: {
    updatePosterImage() {
      // 获取当前屏幕宽度
      this.outerWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
/* 模态框的基本样式 */
.modal {
  display: none; /* 初始时隐藏模态框 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* 半透明黑色背景 */
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 确保模态框在最上层 */
}

/* 显示在模态框中的大图 */
.modal-content {
  max-width: 90%; /* 最大宽度 */
  max-height: 80%; /* 最大高度 */
  object-fit: contain; /* 保持图片比例 */
}

/* 关闭按钮 */
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 30px;
  color: white;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 10000;
}
.product-detail {
  background: #fff;
  font-family: PingFangSC, PingFang SC;
  .product-card {
    width: 1200px;
    height: 520px;
    border: 1px solid #979797;
    margin: 40px auto;
  }
  .description {
    width: 1200px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
    font-size: 22px;
    color: #000000;
    background: rgba(0, 0, 0, 0.05);
    padding-left: 22px;
  }
  .product-box {
    display: flex;
    .name {
      font-weight: 600;
      font-size: 22px;
      color: #000000;
      line-height: 30px;
      margin-top: 70px;
      padding-bottom: 18px;
      width: 540px;
      border-bottom: 1px solid #979797;
    }
    .main {
      margin-left: 50px;
    }
  }
  .product-cover {
    width: 430px;
    height: 430px;
    object-fit: cover;
    margin: 20px 0 20px 22px;
  }

  .product-info {
    text-align: center;
    margin: 40px 0 90px 0;
  }
  .product-image {
    width: 1200px;
    object-fit: cover;
    margin-bottom: 25px;
  }
}
.content-box li:before {
  content: '•'; /* 使用自定义字符作为列表项前缀 */
  color: rgba(0, 0, 0, 0.3); /* 设置字符颜色 */
  margin-right: 0.5em; /* 设置字符和列表项文本之间的间距 */
  /* 你可以在这里添加更多样式，比如字体大小、样式等 */
}
.content-box {
  width: 600px;
  margin-top: 40px;
  li {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .content {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
  }
}

@media (max-width: 768px) {
  .product-detail {
    background: rgba(170, 212, 250, 0.1);
    font-family: PingFangSC, PingFang SC;
    .product-card {
      width: 348px;
      height: 100%;
      border: 1px solid #979797;
      margin: 12px auto;
      background: #fff;
    }
    .description {
      width: 348px;
      height: 25px;
      line-height: 25px;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      background: rgba(0, 0, 0, 0.05);
      padding-left: 10px;
    }
    .product-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name {
        font-weight: 600;
        font-size: 15px;
        color: #000000;
        line-height: 21px;
        margin-top: 15px;
        padding-bottom: 4px;
        width: 300px;
        border-bottom: 1px solid #979797;
      }
      .main {
        margin-left: 23px;
        margin-bottom: 10px;
      }
    }
    .product-cover {
      width: 320px;
      height: 320px;
      object-fit: cover;
      margin: 10px auto;
    }

    .product-info {
      text-align: center;
      margin: 8px 0 23px 0;
    }
    .product-image {
      width: 348px;
      object-fit: cover;
      margin-bottom: 9px;
    }
  }
  .content-box {
    width: 310px;
    margin-top: 12px;
    li {
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      line-height: 17px;
      margin-bottom: 10px;
    }
    .content {
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      line-height: 17px;
    }
  }
}
</style>
<style lang="scss"></style>
